// import * as Cookies from 'js-cookie';

export default {
    data() {
        return {
            pagination: {
                total: 0,
                pageSize: 50,
                current: 1,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["20", "50", "100", "200"],
                showTotal: (total, range) => `${range[0]}-${range[1]} , 共 ${total} 条`,
            },
        };
    },
    methods: {
        on_pagination_change(e) {
            let newQuery = JSON.parse(JSON.stringify(this.$route.query));
            newQuery["page"] = e.current;
            newQuery["per_page"] = e.pageSize;

            //Cookies.set('per_page',e.pageSize)
            this.$router.push(`${this.path}?${this.objectToQuery(newQuery)}`);
        },
        on_pagination_change_common(page, pageSize) {
            this.on_pagination_change({ current: page, pageSize: pageSize });
        },
    },
};
